<script lang="ts">
  import { page } from "$app/stores";
  import SidePanelInnerLayout from "$components/+layout/SidePanel/SidePanelInnerLayout.svelte";
  import Dropdown from "$components/+blocks/Dropdown/Dropdown.svelte";
  import Action from "$components/+blocks/Dropdown/fields/Action.svelte";
  import IconButtonTrigger from "$components/+blocks/Dropdown/fields/IconButtonTrigger.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import { saveToClipboard } from "$utils/clipboard";
  import { alerts } from "$stores/alert";
  import { Dots, Link, Revert, Doc } from "$components/+blocks/OVIcon";
  import { isDarkTheme } from "app/stores/userPreferences";
  import DocMetadataPanel from "./DocMetadataPanel.svelte";
  import * as Y from "yjs";
  import { getStores } from "app/stores";
  import { generateYDoc } from "../editor/io";
  import { hasPermission } from "app/stores/permissions";
  import { DocumentPermission } from "@outverse-video/outverse-api-client-lib";

  export let doc;
  export let ydoc;
  export let versionHistoryModalOpen;

  $: canEdit = hasPermission($doc.myPermissions, DocumentPermission.ChangeDocument);

  const { user } = getStores();
</script>

{#key $doc.uuid}
  {#if $doc.content}
    <SidePanelInnerLayout>
      <svelte:fragment slot="actionButton">
        <Dropdown>
          <IconButtonTrigger
            slot="trigger"
            icon={Dots}
            a11yLabel="Document options"
            let:active
            {active}
          />
          <Action
            icon={Link}
            title="Copy link"
            on:click={() => saveToClipboard($page.url.toString(), alerts.add)}
          />
          {#if $user.isAuthed && $user.email?.endsWith("@outverse.com")}
            <Action
              icon={Revert}
              title="Reset ydoc to json"
              on:click={() => {
                Y.applyUpdate($ydoc.doc, Y.encodeStateAsUpdate(generateYDoc($doc.content.json)));
              }}
            />
          {/if}
        </Dropdown>
      </svelte:fragment>

      <div
        class="col-start-2 col-end-3 mx-auto flex items-center gap-2 text-sm font-medium text-neutral-500/90 md:text-[13px] dark:text-neutral-100"
        slot="title"
      >
        {#if $doc.icon}
          {@const icon = $isDarkTheme && $doc.iconDark ? $doc.iconDark : $doc.icon}
          <div>
            <Avatar mainImage={icon} radius="rounded-[3px]" />
          </div>
        {:else}
          <OVIcon size="size-3.5" icon={Doc} />
        {/if}
        <span class="max-w-[22ch] truncate">{$doc?.title}</span>
      </div>

      <svelte:fragment slot="content">
        <DocMetadataPanel {doc} {ydoc} {versionHistoryModalOpen} {canEdit} />
      </svelte:fragment>
    </SidePanelInnerLayout>
  {/if}
{/key}
